import { Component } from '@angular/core';
import { FilterField, FilterOperator, FindOptions, Ticket } from 'src/app/models';
import { AbstractService } from 'src/app/shared/services';
import { constants } from '@app/shared/utils/constants';
import { AbstractTicketListComponent } from '../abstract-ticket-list/abstract-ticket-list.component';

@Component({
  selector: 'app-tc-ticket-list-beta',
  templateUrl: './tc-ticket-list-beta.component.html',
  styles: [],
  standalone: false,
})
export class TcTicketListBetaComponent extends AbstractTicketListComponent {
  ticketsTypes = constants.ticketcenter.ticketsTypes;
  allTickets: Ticket[] = [];

  override findOptions: FindOptions = {
    orderBy: 'tickets.created_at',
    orderDirection: 'desc',
    storageKey: 'tickets-find-options',
    q: '',
    perPage: 30,
    fields: [
      {
        label: 'Nº',
        sortField: 'tickets.ticket_number_teorema',
        columnClass: 'text-center',
      },
      {
        label: 'Aberto em',
        sortField: 'tickets.created_at',
      },
      // {
      //   label: 'Problema',
      // },
      {
        label: 'Responsável',
        sortField: 'responsible_users.name',
      },
      // {
      //   label: 'Executor',
      // },
      {
        label: 'Cliente',
        sortField: 'persons.name',
      },
      // {
      //   label: 'Solicitante',
      // },
      {
        label: 'Sistema',
        sortField: 'systems.description',
      },
      // {
      //   label: 'Projeto',
      // },
      {
        label: 'Desenvolvedor',
        sortField: 'developer_users.name',
      },
      // {
      //   label: 'Esf. Tec',
      // },
      // {
      //   label: 'Fase',
      // },
      // {
      //   label: 'Responsável',
      // },
      {
        label: 'Status',
        sortField: 'ticket_statuses.description',
      },
      // {
      //   label: 'Sprint',
      // },
      // {
      //   label: 'Prioridade',
      // },
      {
        label: 'Previsão',
        sortField: 'tickets.expected_date',
      },
    ],
    reset: 25,
    filters: [
      new FilterField({
        name: 'situation',
        type: 'radio',
        label: 'Situação',
        options: [
          { value: 'A', label: 'Aberto' },
          { value: 'F', label: 'Fechado' },
        ],
        value: 'A',
      }),
      new FilterField({
        name: 'date_range',
        key: 'date_range',
        label: 'Data de abertura',
        type: 'betweenDates',
        operator: FilterOperator.between,
      }),
      new FilterField({
        name: 'tickets.type',
        type: 'select',
        label: 'Tipo',
        options: this.ticketsTypes,
        multiple: true,
      }),
      new FilterField({
        name: 'tickets.ticket_type_id',
        type: 'select',
        label: 'Tipo chamada',
        modelName: 'ticket-types',
        bindLabel: 'description',
        bindValue: 'id',
        multiple: true,
      }),
      new FilterField({
        name: 'number',
        key: 'tickets.ticket_number_teorema',
        label: 'Número',
        type: 'text',
        operator: FilterOperator.equal,
      }),
      new FilterField({
        name: 'problem',
        key: 'tickets.problem',
        label: 'Problema',
        type: 'text',
        operator: FilterOperator.like,
      }),
      new FilterField({
        name: 'requester',
        key: 'tickets.requester',
        label: 'Solicitante',
        type: 'text',
        operator: FilterOperator.like,
      }),
      new FilterField({
        name: 'systems',
        key: 'tickets.system_id',
        label: 'Sistema',
        type: 'select',
        modelName: 'systems',
        bindLabel: 'description',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'customers',
        key: 'tickets.customer_id',
        label: 'Cliente',
        type: 'select',
        multiple: true,
        modelName: 'customers',
        bindLabel: '_name',
        bindValue: 'id',
        orderBy: 'persons.name',
      }),
      new FilterField({
        name: 'developer',
        multiple: true,
        label: 'Desenvolvedor',
        type: 'select',
        modelName: 'users',
        bindLabel: 'name',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'sprint',
        key: 'tickets.sprint_id',
        label: 'Sprint',
        type: 'select',
        modelName: 'sprints',
        bindLabel: 'description',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'phases',
        key: 'tickets.phase_id',
        label: 'Fase',
        type: 'select',
        modelName: 'phases',
        bindLabel: 'description',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'projects',
        key: 'tickets.project_id',
        label: 'Projeto',
        type: 'select',
        modelName: 'projects',
        bindLabel: 'description',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'companies',
        key: 'tickets.company_id',
        label: 'Empresa',
        type: 'select',
        modelName: 'companies',
        bindLabel: '_name',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'responsible',
        multiple: true,
        label: 'Responsável',
        type: 'select',
        modelName: 'users',
        bindLabel: 'name',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'executor',
        multiple: true,
        label: 'Executor',
        type: 'select',
        modelName: 'users',
        bindLabel: 'name',
        bindValue: 'id',
      }),
    ],
  };

  override async findTicket() {
    this.loading = true;
    try {
      const filters = this.buildFiltersForMassive();
      const response = await this.tcTicketService.listMassive(filters);

      if (response?.data) {
        this.allTickets = response.data;
        this.totalItems = response.total || 0;
        this.paginateLocal();
      }
    } catch (error) {
      this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
    } finally {
      this.loading = false;
    }
  }

  private buildFiltersForMassive(): any {
    const filters: any = {};

    if (this.findOptions?.filters) {
      this.findOptions.filters.forEach((filter: any) => {
        if (filter.value !== undefined && filter.value !== null && filter.value !== '') {
          // Mapear filtro de datas
          if (
            filter.name === 'date_range' &&
            Array.isArray(filter.value) &&
            filter.value.length === 2
          ) {
            filters.date_from = filter.value[0];
            filters.date_to = filter.value[1];
          } else if (filter.name === 'situation') {
            // Situation é enviado diretamente
            filters.situation = filter.value;
          } else if (filter.name === 'responsible') {
            // Responsible é enviado como responsible_id
            filters.responsible_id = filter.value;
          } else if (filter.name === 'developer') {
            // Developer é enviado como developer_id
            filters.developer_id = filter.value;
          } else {
            // Outros filtros são ignorados por enquanto (não suportados pela API massive)
            // filters[filter.name] = filter.value;
          }
        }
      });
    }

    if (this.findOptions?.q) {
      filters.q = this.findOptions.q;
    }

    console.log('Filters being sent to API:', filters);
    return filters;
  }

  private paginateLocal() {
    const pageSize = this.findOptions.perPage || 10;
    const page = this.findOptions.page || 1;
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    this.tickets = this.allTickets.slice(startIndex, endIndex);
  }

  override paginate(findOptions?: FindOptions) {
    if (findOptions) this.findOptions = { ...this.findOptions, ...findOptions };

    if (this.findOptions?.q) {
      this.searchWidget.updateValue(this.findOptions.q);
    }

    // Se tem dados em memória, usa paginação local (mudança de página)
    if (this.allTickets.length > 0) {
      this.paginateLocal();
    } else {
      // Se não tem dados, carrega da API
      this.findTicket();
    }
  }

  override goToFirstPage() {
    this.allTickets = [];
    this.findOptions.page = 1;
    this.findTicket();
    if (this.paginator) {
      this.paginator.component.first = 0;
    }
  }

  override applyOrder(orderBy: any[]) {
    this.findOptions.orderBy = orderBy;

    // Ordena os dados em memória (sem chamar paginate que faria requisição)
    if (this.allTickets.length > 0) {
      this.sortLocalData();
      this.paginateLocal();
      // Atualiza meta da tabela sem fazer requisição
      if (this.table) {
        this.table.updateSortMeta(this.findOptions);
      }
    }
  }

  private sortLocalData() {
    if (!this.findOptions.orderBy || this.allTickets.length === 0) {
      return;
    }

    const orderByArray = Array.isArray(this.findOptions.orderBy)
      ? this.findOptions.orderBy
      : [{ field: this.findOptions.orderBy as string, direction: this.findOptions.orderDirection }];

    this.allTickets.sort((a: any, b: any) => {
      for (const order of orderByArray) {
        const field = typeof order === 'string' ? order : (order.field as string);
        const direction =
          (typeof order === 'object' ? order.direction : this.findOptions.orderDirection) || 'asc';

        const aValue = this.getNestedValue(a, field);
        const bValue = this.getNestedValue(b, field);

        let comparison = 0;
        if (aValue < bValue) {
          comparison = -1;
        } else if (aValue > bValue) {
          comparison = 1;
        }

        if (comparison !== 0) {
          return direction.toLowerCase() === 'desc' ? -comparison : comparison;
        }
      }
      return 0;
    });
  }

  private getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((current, prop) => current?.[prop], obj);
  }

  override onRowClicked(ticket: Ticket) {
    this.router.navigate([`/chamados/editar/${ticket.id}`]);
  }

  override getService(): AbstractService<Ticket> {
    return this.tcTicketService;
  }

  override get openTicketRoute(): string {
    return '/chamados/novo';
  }
}
